import { Controller } from "@hotwired/stimulus"

import Dropzone from "dropzone"

import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    Dropzone.autoDiscover = false
    this.inputTarget.disable = true
    this.inputTarget.style.display = "none"
    const dropzone = new Dropzone(this.element, {
      url: '/',
      maxFiles: '500',
      maxFilesize: '1000',
      // 10 minute timeout
      timeout: 600000,
      autoQueue: false
    })

    // dropzone.on("addedfile", file => {
    //   setTimeout(() => {
    //     if (file.accepted) {
    //       const upload = new DirectUpload(file, this.url)
    //       upload.create((error, blob) => {
    //         this.hiddenInput = document.createElement("input")
    //         this.hiddenInput.type = "hidden"
    //         this.hiddenInput.name = this.inputTarget.name
    //         this.hiddenInput.value = blob.signed_id
    //         this.inputTarget.parentNode.insertBefore(this.hiddenInput, this.inputTarget.nextSibling)
    //         dropzone.emit("success", file)
    //         dropzone.emit("complete", file)
    //       })
    //     }
    //   }, 500)
    // })
  }

  get url() {
    return this.inputTarget.getAttribute('data-direct-upload-url')
  }
}